module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iNDgiPjxwYXRoIGQ9Ik0xOTYtMzMxcS0yMC0zNi0yOC03Mi41dC04LTc0LjVxMC0xMzEgOTQuNS0yMjUuNVQ0ODAtNzk4aDQzbC04MC04MCAzOS0zOSAxNDkgMTQ5LTE0OSAxNDktNDAtNDAgNzktNzloLTQxcS0xMDcgMC0xODMuNSA3Ni41VDIyMC00NzhxMCAyOSA1LjUgNTV0MTMuNSA0OWwtNDMgNDNaTTQ3Ni00MCAzMjctMTg5bDE0OS0xNDkgMzkgMzktODAgODBoNDVxMTA3IDAgMTgzLjUtNzYuNVQ3NDAtNDc5cTAtMjktNS01NXQtMTUtNDlsNDMtNDNxMjAgMzYgMjguNSA3Mi41VDgwMC00NzlxMCAxMzEtOTQuNSAyMjUuNVQ0ODAtMTU5aC00NWw4MCA4MC0zOSAzOVoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./static/icons/change_black.svg
// module id = pdSV
// module chunks = 1